export const Assets =
{
  presenterIdleURL: '/assets/footage/BB5F566E-797E-4C62-9F66-B18D0010A1D9.mp4',
  coHostIdleURL: '/assets/footage/8DAC304B-7610-4DCB-B81C-1A1536C67EC0.mp4',
  silenceURL: '/assets/footage/silence.wav',
  idleURLs: ['/assets/footage/BB5F566E-797E-4C62-9F66-B18D0010A1D9.mp4', '/assets/footage/8DAC304B-7610-4DCB-B81C-1A1536C67EC0.mp4']
}
